import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

import {
  DeleteLegalNitrogenWorkingCoefficientResponse,
  GetLegalNitrogenWorkingCoefficients,
  LegalNitrogenWorkingCoefficient,
  LegalNitrogenWorkingCoefficientsFilter,
  UpsertLegalNitrogenWorkingCoefficientResponse,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class LegalNitrogenWorkingCoefficientService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/field-report/secure/legalnitrogenworkingcoefficient';

  getLegalNitrogenWorkingCoefficients(
    pageNumber: number,
    pageSize: number,
    filter: LegalNitrogenWorkingCoefficientsFilter,
  ): Observable<GetLegalNitrogenWorkingCoefficients> {
    let url = `${this.baseUrl}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (filter.year) {
      url += `&calendarYear=${filter.year}`;
    }
    return this.http.get<GetLegalNitrogenWorkingCoefficients>(url);
  }

  upsertLegalNitrogenWorkingCoefficient(legalNitrogenWorkingCoefficient: LegalNitrogenWorkingCoefficient) {
    return this.http.post<UpsertLegalNitrogenWorkingCoefficientResponse>(this.baseUrl, legalNitrogenWorkingCoefficient, {});
  }

  deleteLegalNitrogenWorkingCoefficient(legalNitrogenWorkingCoefficientsId: number) {
    return this.http.delete<DeleteLegalNitrogenWorkingCoefficientResponse>(this.baseUrl + '/' + legalNitrogenWorkingCoefficientsId);
  }
}
